import { ca } from '@cian/analytics';

export function trackHelpCenterLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FeedBackForm',
    action: 'Click',
    label: 'HelpCenter',
  });
}
